import { type LucideProps } from 'lucide-react'

/**
 * Unlock Icon (Custom Design)
 *
 * Open lock icon matching the app's design system.
 * Same shackle radii as Lock (3.5 outer, 2 inner). Entire icon shifted
 * 2u left so it centers visually (1u padding each side). Shackle raised
 * (center y=3.5 vs lock's 4.5) to convey "lifted up and over."
 * Body: x=1-11, y=7-15. Shackle center: (11.5, 3.5).
 */
export function Unlock({ size = 24, className = '', ...props }: LucideProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
      {...props}
    >
      <path d="M8 7V3.5A3.5 3.5 0 0 1 15 3.5v1.5a.75.75 0 0 1-1.5 0V3.5A2 2 0 0 0 9.5 3.5V7A1.5 1.5 0 0 1 11 8.5v5a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 1 13.5v-5A1.5 1.5 0 0 1 2.5 7Z" />
    </svg>
  )
}
